/**
 * @memberOf loavies.models.image
 * @constructor
 */
export class ImageVariantsModel {
  /**
   * @param {loavies.models.image.ImageVariantModel} original
   * @param {loavies.models.image.ImageVariantModel} w200
   * @param {loavies.models.image.ImageVariantModel} w400
   * @param {loavies.models.image.ImageVariantModel} w600
   * @param {loavies.models.image.ImageVariantModel} w900
   * @param {loavies.models.image.ImageVariantModel} w1000
   */
  constructor({
    original,
    w200,
    w400,
    w600,
    w900,
    w1000,
  }) {

    /** @type {loavies.models.image.ImageVariantModel} */
    this.original = original

    /** @type {loavies.models.image.ImageVariantModel} */
    this.w200 = w200

    /** @type {loavies.models.image.ImageVariantModel} */
    this.w400 = w400

    /** @type {loavies.models.image.ImageVariantModel} */
    this.w600 = w600

    /** @type {loavies.models.image.ImageVariantModel} */
    this.w900 = w900

    /** @type {loavies.models.image.ImageVariantModel} */
    this.w1000 = w1000
  }
}
